import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

import * as settingActions from '../store/actions/settings.actions';

@Injectable()
export class ThirdPartiesLeeOResolver {
  constructor(private readonly store: Store<RootState>) {}

  resolve() {
    this.store.dispatch(settingActions.loadLeeOAuthenticationRequest());

    return of(true);
  }
}
